import Subscription from "./subscription";
import UserGroup from "./userGroup";

export default class User {
  public idUser: number = 0;
  public username: string = ""; //
  public email: string = ""; //
  public password: string = ""; //
  public firstName: string = "";
  public lastName: string = "";
  public phone: string = "";
  public title: string = "";
  public userGroups: UserGroup[] = [];
  public subscriptions: Subscription[] = [];

  public onUserInfoChanged: any;

  // public getName = () => {
  //   return `${this.firstName} ${this.lastName}`;
  // };

  // public getName(): string {
  //   return `${this.firstName} ${this.lastName}`;
  // }

  // public updateName(): void {
  //   this.name = `${this.firstName} ${this.lastName}`;
  // }   /// oana commented this because i was having compiling error when creating a new user by using spread operator
}
